<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

const tips = [
  {
    header: 'Fields',
    body: [
      `First Name and Last Name are required but can be partial names. It is 
      recommended to add as much information as available to obtain the best match 
      result.`,
    ],
  },
  {
    header: 'Match Method',
    body: [
      `A Matching Engine search is the same logic used for the assignment process, 
      while the SQL search is SQL only and will not include a Match Score.`,
    ],
  },
  {
    header: 'Search In',
    body: [
      `Master: The search request will be performed against the Master data using the 
      Search Type.`,
      `Submission: The search request will be performed against previously submitted 
      records from Submission. Access to this search is limited.`,
      `History: The search request will be performed against the History data using 
      the Search Type.`,
    ],
  },
  {
    header: 'Results',
    body: [
      'Drilling into the results take the user to the Person Information page.',
    ],
  },
];

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips,
    };
  },
};
</script>
